module.exports = __webpack_public_path__ + "static/inexa_logo-c5ec75ea3b4ba8c0337854be4d7d039f.png";